import script from "./downFilePdf.vue?vue&type=script&lang=ts&setup=true"
export * from "./downFilePdf.vue?vue&type=script&lang=ts&setup=true"

import "./downFilePdf.vue?vue&type=style&index=0&id=5def7fb9&lang=scss"

const __exports__ = script;

export default __exports__